var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkGreen = function SvgCheckmarkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.576 12a.667.667 0 0 1-.486-.21L2.848 8.337a.666.666 0 1 1 .971-.912l2.75 2.927 5.606-6.135a.667.667 0 0 1 .984.899l-6.091 6.667A.665.665 0 0 1 6.58 12h-.005Z",
    fill: "#008545"
  })));
};
export default SvgCheckmarkGreen;